import { useRouter } from 'next/navigation';
import { useCallback } from 'react';
import type { User as FirebaseUser } from 'firebase/auth';
export const useAuthToken = () => {
  const router = useRouter();
  const setAuthToken = useCallback(async (token: string, redirect?: string): Promise<boolean> => {
    console.log('setAuthToken');
    try {
      const response = await fetch('/api/auth/set-token', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          token,
          redirect
        })
      });
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error ?? 'Failed to set auth token');
      }
      // refresh the router to update redirects of the pages that require authentication
      router.refresh();
      return true;
    } catch (error) {
      console.error('Failed to set auth token:', error);
      return false;
    }
  }, [router]);
  const clearAuthToken = useCallback(async (): Promise<boolean> => {
    if (process.env.NODE_ENV === 'development') {
      console.trace('clearAuthToken');
    }
    try {
      const response_0 = await fetch('/api/auth/set-token', {
        method: 'DELETE'
      });
      if (!response_0.ok) {
        console.warn('Failed to clear auth token via API');
      }
      // refresh the router to update redirects of the pages that require authentication
      router.refresh();
      return true;
    } catch (error_0) {
      console.error('Failed to clear auth token:', error_0);
      return false;
    }
  }, [router]);
  const refreshAndSetToken = useCallback(async (user: FirebaseUser, redirect_0?: string): Promise<string | null> => {
    try {
      const token_0 = await user.getIdToken(true); // Force refresh
      const success = await setAuthToken(token_0, redirect_0);
      if (!success) {
        throw new Error('Failed to set refreshed token');
      }
      return token_0;
    } catch (error_1) {
      console.error('Failed to refresh and set token:', error_1);
      return null;
    }
  }, [setAuthToken]);
  return {
    clearAuthToken,
    refreshAndSetToken
  };
};